export function promisify(name: string) {
    return (obj: any) => {
        return new Promise((resolve, reject) => {
            obj = obj || {};
            obj.success = () => {
                resolve();
            };
            obj.complete = (err: any) => {
                // resolve();
            };
            obj.fail = (err: any) => {
                reject();
            };
            // @ts-ignore
            wx[name](obj);
        }).catch((err) => {
            return err;
        });
    };
}

// api
const apiNames = [
    'onMenuShareAppMessage',
    'onMenuShareTimeline',
    'chooseImage',
    'previewImage',
    'uploadImage',
    'downloadImage',
    'closeWindow',
    'hideOptionMenu',
    'chooseWXPay',
    'getLocation',
    'getLocalImgData',
    'hideMenuItems',
    'showMenuItems',
    'updateAppMessageShareData',
    'updateTimelineShareData',
    'onMenuShareQQ',
    'onMenuShareWeibo',
    'onMenuShareQZone',
];
export const wxApi = {};
apiNames.forEach((name: string) => {
    // @ts-ignore
    wxApi[name] = promisify(name);
});
